// Shared ElectricSheep Supabase client used across the app.
// This replaces the auto-generated supabase client so all auth/reads/writes
// go through the shared ElectricSheep project and its compatibility Edge Functions.
import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://rhfojelkgtwcxnrfhtlj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJoZm9qZWxrZ3R3Y3hucmZodGxqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMyNDM1NzYsImV4cCI6MjA4ODgxOTU3Nn0.X8mJHaYIolCmx6j_473GGb05OyFTy43Hq-BEelZRjAE";

export const SHARED_SUPABASE_URL = SUPABASE_URL;
export const SHARED_SUPABASE_PUBLISHABLE_KEY = SUPABASE_PUBLISHABLE_KEY;

// Untyped client — the auto-generated Database type reflects the Lovable Cloud
// schema, not the shared ElectricSheep schema. Ambassador surface goes through
// edge functions for reads, so we don't need typed table access here.
export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: "pkce",
  },
});